import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { LatestVisit } from '../../domaine/dashboardModel';

interface LatestVisitsTableProps {
  data: LatestVisit[] | undefined;
}

const LatestVisitsTable: React.FC<LatestVisitsTableProps> = ({ data }) => {
  const columns: ColumnsType<LatestVisit> = [
    {
      title: 'Date de la visite',
      dataIndex: 'date_visite',
      key: 'date_visite',
      render: (date: Date) => new Date(date).toLocaleDateString(), // Format the date
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
    {
      title: 'Project',
      dataIndex: 'projet',
      key: 'projet',
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
    {
      title: 'Tranche',
      dataIndex: 'tranche',
      key: 'tranche',
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
    {
      title: 'Utilisateur',
      dataIndex: 'utilisateur',
      key: 'utilisateur',
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="id"
      pagination={false} // Disable pagination if not needed
      bordered
      size="small"
    />
  );
};

export default LatestVisitsTable;